var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "48px",
    viewBox: "0 0 35 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-550.000000, -281.000000)",
    fill: "#54575A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.000000, 281.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,0 C7.88017473,0 0.0539112903,7.7983125 0.0539112903,17.3836875 C0.0539112903,29.2794375 15.6664516,46.7430937 16.3311694,47.4807188 C16.9555242,48.173625 18.0456048,48.1724063 18.6688306,47.4807188 C19.3335484,46.7430937 34.9460887,29.2794375 34.9460887,17.3836875 C34.9460887,7.7983125 27.1197312,0 17.5,0 Z M17.5,44.0370938 C12.245578,37.8179063 3.19563172,25.548 3.19563172,17.383875 C3.19563172,9.5244375 9.61248656,3.1305 17.5,3.1305 C25.3875134,3.1305 31.8043683,9.5244375 31.8043683,17.3837813 C31.8043683,25.5482813 22.7557392,37.8159375 17.5,44.0370938 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,8.6375625 C12.6600269,8.6375625 8.72252688,12.5610938 8.72252688,17.3837813 C8.72252688,22.2064688 12.660121,26.13 17.5,26.13 C22.339879,26.13 26.277379,22.2064688 26.277379,17.3837813 C26.277379,12.5610938 22.339879,8.6375625 17.5,8.6375625 Z M17.5,22.9995 C14.3923387,22.9995 11.8642473,20.4803437 11.8642473,17.3837812 C11.8642473,14.2872187 14.3924328,11.7680625 17.5,11.7680625 C20.6075672,11.7680625 23.1357527,14.2872187 23.1357527,17.3837812 C23.1357527,20.4803437 20.6075672,22.9995 17.5,22.9995 Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/map-point.63c93b575eba103ded0d2b1429b2c2c3.svg";
export { ForwardRef as ReactComponent };